module.exports = __webpack_public_path__ + "static/Gilroy-Black-a5e18ce935001d241734d402ae6efce6.woff";